<script setup>
  import { ref } from 'vue'
  import { __ } from '../../../assets/javascripts/library.js'
  import Modal from '../../../assets/components/Modal.vue'
  import ExpenseAccounting from './expense-accounting.vue'
  import { notify } from '../../../assets/javascripts/library';
  import { defineComponent } from 'vue'
  import TravelExpenseAccounting from "./travel-expense-accounting.vue";


  const data = defineProps({
    events: Object,
    jobs: Object,
    dynamictext: Object,
    user_name: String,
    user_email: String,
    user_iban: String,
    user_account_owner: String,
    distance_allowance: Number,
    user_id: Number
  })

  const isOpen = ref(false)
  const eventId = ref(0);
  const invoiceType = ref('');
</script>

<template>
  <div v-if="eventId === 0">
    <h2>{{__('New invoice', 'mareike')}}</h2>

    <div id="mareike_new_invoice_index_table">
      <div
          @click="isOpen = true;invoiceType='expense-accounting'"
          class="mareike-div-selector"
      >
        <h3>{{ __('Expense accounting', 'mareike')}}</h3>
        <p v-html="data.dynamictext.INFO_EXPENSE_ACCOUNTING" />
      </div>
      <div
          @click="isOpen = true;invoiceType='travel-expense-accounting'"
          class="mareike-div-selector"
      >
        <h3>{{__('Travel expense accounting', 'mareike' ) }}</h3>
        <p v-html="data.dynamictext.INFO_TRAVEL_EXPENSE_ACCOUNTING" />
      </div>
    </div>
  </div>

  <div v-else>
    <ExpenseAccounting v-if="invoiceType === 'expense-accounting'"
       :eventId="eventId"
       :dynamicText="data.dynamictext"
       :user_name="data.user_name"
       :user_email="data.user_email"
       :user_iban="data.user_iban"
       :user_account_owner="data.user_account_owner"
       :user_id="data.user_id"
    />

    <TravelExpenseAccounting v-else-if="invoiceType === 'travel-expense-accounting'"
       :eventId="eventId"
       :dynamicText="data.dynamictext"
       :user_name="data.user_name"
       :user_email="data.user_email"
       :user_iban="data.user_iban"
       :distance_allowance="data.distance_allowance"
       :user_account_owner="data.user_account_owner"
       :user_id="data.user_id"
    />
  </div>

    <Modal :show="isOpen" :title="__('Select event', 'mareike')" @close="isOpen = false">
      <select class="mareike-select" v-model="eventId" @change="isOpen=false" style="width: 100%">
        <option value="0" disabled>{{__('Please select', 'mareike' ) }}</option>
        <optgroup :label="__( 'Current jobs', 'mareike' )">
          <option :value="event.id" v-for="event in data.jobs">{{ event.cost_unit_name }}</option>
        </optgroup>

        <optgroup :label="__( 'Current events', 'mareike' )">
          <option :value="event.id" v-for="event in data.events">{{ event.cost_unit_name }}</option>
        </optgroup>
      </select>
    </Modal>

</template>
